import type { TvChannel } from '@setplex/tria-api'

export const NO_EPG_ID = '0'

// instead of `TimeRange` = { start: number, end: number } -> just immutable tuple
export type Range = readonly [number, number]

// params for epg request
export type EpgRequestParams = {
  channels: TvChannel[]
  period?: Range | null
}

// epg info for single program
export type ProgramEpgInfo = {
  start: string
  stop: string
  title?: string
  description?: string
  subtitle?: string
  categories: string[]
  icon?: string
  date?: string
  rating?: string
  directors: string[]
  actors: string[]
  episode?: string
  labels?: string[]
}

export const State = {
  Elapsed: 0,
  Ongoing: 1,
  Upcoming: 2,
} as const
export type State = (typeof State)[keyof typeof State]

export const Day = {
  Ereyesterday: 0,
  Yesterday: 1,
  Today: 2,
  Tomorrow: 3,
  Overmorrow: 4,
} as const
export type Day = (typeof Day)[keyof typeof Day]

// range position in time, relative to exact time moment "now"
export type RangePosition = {
  state: State
  starts: Day
  ends: Day
}
